"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTR_STATIC_TEMPLATE_PREVIEW = void 0;
exports.RTR_STATIC_TEMPLATE_PREVIEW = {
    headline: "HHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHH",
    addressLine: "HHHH HHHHH HHHH HHHHHHHHHHHHH HHHH HHHH HHHHH HHHH",
    price: "HHH HHHH HHH",
    bedCount: "HH",
    bathCount: "HH",
    stageName: "HHH CUSTOM H STAGE HHH",
};
